import React from 'react';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import api from '../../ApiService';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';

import { ModalOKCancel } from '../../modals';
import AffiliateGroupsEditor from './AffiliateGroupsEditor';

import { toast } from 'react-toastify';


export default class AffiliateGroups extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            affiliateGroups: [],
            gpoGroups: [],
            sortedAffiliateGroups: [],
            affiliates: [],
            affiliateGroupHospitals: [],
            filter: 'select',
            isDirty:false,
            loadingHospitals: false,
            showCancelModal: false
        };

        this.onSort = this.onSort.bind(this);
    }

    componentDidMount = async () => {
        let data = await api.getAffiliateGroups();
        let filter = data.affiliates[0].id;
        let sortedAffiliateGroups = data.affiliateGroups.filter(x => x.affiliateId === filter);
        this.setState({
            affiliateGroups: data.affiliateGroups,
            affiliates: data.affiliates,
            gpoGroups: data.gpoGroups,
            sortedAffiliateGroups,
            filter
        });
    }

    onAffiliateSelect = async (e, rowData) => {
        this.setState({
            affiliateId: rowData.affiliateId,
            affiliateName: this.state.affiliates.find(x => x.id === rowData.affiliateId).name,
            affiliateGroup: rowData,
            isEditing: true
        });
    }

    handleFilterChange = async (e) => {
        let filter = e.target.value;
        let sortedAffiliateGroups = this.state.affiliateGroups.filter(x => x.affiliateId === filter);
        this.setState({ filter, sortedAffiliateGroups });
    }

    onConfirmCancel = async (e) => {
        // reload from server
        let data = await api.getAffiliateGroups();
        let sortedAffiliateGroups = data.affiliateGroups.filter(x => x.affiliateId === this.state.filter);
        this.setState({
            affiliateGroups: data.affiliateGroups,
            affiliates: data.affiliates,
            gpoGroups: data.gpoGroups,
            sortedAffiliateGroups: sortedAffiliateGroups,
            isEditing: false,
            isDirty: false
        });
        toast.success("Changes canceled.");
    }

    onClickCancel = async (e) => {
        e.preventDefault();
        if (!this.state.isDirty) {
            await this.onConfirmCancel();
            return;
        }
        else {
            this.setState({ showCancelModal: true });
        }
    }

    onClickSave = async () => {
        let items = this.state.sortedAffiliateGroups;
        let item = items.find(item => item.id === 0);
        item.affiliateId = this.state.filter;

        let success = await api.saveAffiliateGroups(item);
        if (success) {
            let data = await api.getAffiliateGroups();
            let sortedAffiliateGroups = data.affiliateGroups.filter(x => x.affiliateId === this.state.filter);
            this.setState({
                affiliateGroups: data.affiliateGroups,
                affiliates: data.affiliates,
                gpoGroups: data.gpoGroups,
                sortedAffiliateGroups: sortedAffiliateGroups,
                isDirty: false
            });
            toast.success(`Affiliate Groups updated.`);
        }
    }

    onEditorValueChange = (e) => {
        // just set the dirty flag
        if (!this.state.isDirty) this.setState({ isDirty: true });
    }

    onEditorBlur = (e, props) => {
        if (e.target.defaultValue === e.target.value) return;

        let items = [...props.value];
        if (items[props.rowIndex][props.field] !== e.target.value) {
            items[props.rowIndex][props.field] = e.target.value;
            this.setState({ items });
        }
    }

    onEditorKeyPress = (e, props) => {
        // have to manually handle this since onBlur doesn't make it to our control
        // yes, i'm a little upset about that
        // 9 - tab
        // 13- enter
        if (e.keyCode === 9 || e.keyCode === 13) {
            this.onEditorBlur(e, props);
        }
    }

    editTemplate = (props) => {
        return (
            <InputText type='text' defaultValue={props.rowData[props.field]}
                onBlur={(e) => this.onEditorBlur(e, props)}
                onChange={(e) => this.onEditorValueChange(e)}
                onKeyDown={(e) => this.onEditorKeyPress(e, props)}
            />
        );
    }

    onClickTemplate = (rowData, column) => {
        return <p onClick={(e) => this.onAffiliateSelect(e, rowData)}>{rowData.name}</p>;
    }

    onClickDelete = async (e) => {
        let success = await api.deleteAffiliateGroup(this.state.affiliateGroup.id);
        if (success) {
            let data = await api.getAffiliateGroups();
            let sortedAffiliateGroups = data.affiliateGroups.filter(x => x.affiliateId === this.state.filter);
            this.setState({
                affiliateGroups: data.affiliateGroups,
                affiliates: data.affiliates,
                sortedAffiliateGroups: sortedAffiliateGroups,
                isEditing: false,
                isDirty: false
            });
        }
    }

    removeItem = (e, rowData) => {
        if (rowData.index) {
            // this item was just added
            // (yes, being tricky with the var)
            var sortedAffiliateGroups = this.state.sortedAffiliateGroups.filter(x => x.index !== rowData.index);
        }
        else {
            sortedAffiliateGroups = this.state.sortedAffiliateGroups.filter(x => x.id !== rowData.id);
        }
        this.setState({ sortedAffiliateGroups, isDirty: true });
    }

    addItem = () => {
        if (!this.state.isDirty) {
            let sortedAffiliateGroups = this.state.sortedAffiliateGroups;
            let index = sortedAffiliateGroups.length;
            sortedAffiliateGroups[index] = { id: 0, name: '', index };
            this.setState({ sortedAffiliateGroups, isDirty: true });

            // forcing the focus to the newly added field
            let columns = (document.getElementsByClassName("p-editable-column"));
            setTimeout(() => columns[sortedAffiliateGroups.length - 1].click(), 200);
        }
        window.scrollTo(0, 9999);
    }

    onSort = (e) => {
        let sortedAffiliateGroups = [...this.state.sortedAffiliateGroups];
        sortedAffiliateGroups.sort((a, b) => {
            if (a.name === "") return 1;
            if (b.name === "") return -1;
            if (a.name === b.name) return 0;
            return e.order === 1 ? (a.name < b.name ? -1 : 1) : (a.name < b.name ? 1 : -1);
        });
        return sortedAffiliateGroups;
    }

    renderSaveCancel = (columnSpread) => {
        return (
            <Grid item xs={columnSpread} style={{ textAlign: 'right', display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }} >
                <Button variant='contained' color='default' style={{ marginRight: '15px', width: '80px' }} onClick={this.addItem} disabled={this.state.isDirty}>Add</Button>
                <Button variant='contained' color='default' style={{ marginRight: '15px', width: '80px' }} onClick={this.onClickCancel} disabled={!this.state.isDirty}>Cancel</Button>
                <Button variant='contained' color='primary' style={{ width: '80px' }} onClick={this.onClickSave} disabled={!this.state.isDirty}>Save</Button>
            </Grid>
        );
    }

    renderFilterAndSaveCancel() {
        return (
            <Grid container spacing={0}>
                <Grid item xs={4}>
                    <FormControl fullWidth disabled={this.state.isDirty} >
                        <InputLabel htmlFor="filter" style={{ fontWeight: 'normal' }}>Filter</InputLabel>
                        <Select
                            value={this.state.filter}
                            onChange={this.handleFilterChange}
                            inputProps={{ name: 'filter', id: 'filter' }}
                        >
                            {this.state.affiliates.map((item, i) => {
                                return (
                                    <MenuItem key={i} value={item.id}>{item.name}</MenuItem>
                                );
                            })
                            }
                        </Select>
                    </FormControl>
                </Grid>
                {this.renderSaveCancel(8)}
            </Grid>
        );
    }

    renderDetailsTable() {
        if (this.state.sortedAffiliateGroups) {
            return (
                <div>
                    <DataTable value={this.state.sortedAffiliateGroups}  editable>
                        <Column field="name" header="Name" sortable="custom" sortFunction={this.onSort} style={{ width: '20%' }} body={this.onClickTemplate} editor={this.editTemplate} />
                    </DataTable>
                    <br />
                </div>
            );
        }
    }

    renderCancelModal = () => {
        return (
            <ModalOKCancel
                title={"Discard changes"}
                body={"You have unsaved changes. Click OK to discard your changes."}
                show={this.state.showCancelModal}
                onOK={() => { this.onConfirmCancel(); this.setState({ showCancelModal: false }); }}
                onCancel={() => this.setState({ showCancelModal: false })}
            />
        );
    }

    render() {
        if (this.state.isEditing) {
            return (
                <AffiliateGroupsEditor
                    affiliateId={this.state.affiliateId}
                    affiliateName={this.state.affiliateName}
                    affiliateGroup={this.state.affiliateGroup}
                    onClickCancel={this.onClickCancel}
                    onClickDelete={this.onClickDelete}
                />
            );
        }
        else {
            let filterAndSaveCancel = this.renderFilterAndSaveCancel();

            let mappingDetails = this.renderDetailsTable();
            let affiliateGroupHospitals = this.state.isEditing ? this.affiliateGroupHospitals(): null;
            return (
                <div>
                    <h3>Affiliate Groups</h3>
                    <hr />
                    {filterAndSaveCancel}
                    <br />
                    <br />
                    {mappingDetails}
                    <br />
                    <br />
                    {affiliateGroupHospitals}
                    <br />
                    {this.renderSaveCancel(12)}

                    {this.renderCancelModal()}
                </div>
            );
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/ManageGroups/AffiliateGroups.js